var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-img",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86696",
    "data-name": "\\uD328\\uC2A4 86696",
    d: "M6,10l6,7,6-7H13V1H11v9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86697",
    "data-name": "\\uD328\\uC2A4 86697",
    d: "M22,21H2V15H0v7a1,1,0,0,0,1,1H23a1,1,0,0,0,1-1V15H22Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownImg);
export default __webpack_public_path__ + "static/media/down-img.9efbcc8cfec443c4ef0d0fe4eb304237.svg";
export { ForwardRef as ReactComponent };